import EventCard from '../EventCard';

export const CardsView = ({
  events,
  getDistance,
  fetchEvents,
  favoriteIds,
  applicationStatusMap,
  eventTab,
  currentUserId,
}) => {
  // Group events by month based on their start date
  const monthGroups = {};
  events.forEach((event) => {
    const dateStr = event.date || '9999-12-31';
    const [y, m] = dateStr.split('-').map(Number);
    const monthKey = `${y}-${String(m).padStart(2, '0')}`;
    if (!monthGroups[monthKey]) {
      monthGroups[monthKey] = { events: [], label: '' };
      const d = new Date(y, m - 1, 1);
      monthGroups[monthKey].label = d.toLocaleDateString('en-US', {
        month: 'long',
        year: 'numeric',
      });
    }
    monthGroups[monthKey].events.push(event);
  });
  const sortedKeys = Object.keys(monthGroups).sort();

  return (
    <div className="space-y-8">
      {sortedKeys.map((key) => (
        <div key={key}>
          <div
            className="flex items-center gap-3 mb-4"
            data-testid={`month-header-card-${key}`}
          >
            <div className="h-px flex-1 bg-[#1E3A5F]/20" />
            <h3 className="text-sm font-bold text-[#1E3A5F] uppercase tracking-wider px-3 py-1 bg-[#1E3A5F]/5 rounded-full">
              {monthGroups[key].label} ({monthGroups[key].events.length})
            </h3>
            <div className="h-px flex-1 bg-[#1E3A5F]/20" />
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {monthGroups[key].events.map((event) => (
              <EventCard
                key={event.id}
                event={event}
                distance={getDistance(event)}
                onFavoriteChange={fetchEvents}
                showApplyButton={true}
                applicationStatus={applicationStatusMap[event.id] || null}
                onApplicationChange={fetchEvents}
                isFavorite={favoriteIds.has(event.id)}
                sharedBy={
                  eventTab === 'community' &&
                  event.created_by !== currentUserId &&
                  event.created_by_name
                    ? { name: event.created_by_name }
                    : null
                }
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CardsView;
